import SerialService from '@/api/SerialService'

export const transformBins = (input = []) => {
  return input.map((item) => {
    return {
      'id': item._id,
      'code': item.code,
    }
  })
}

export const transformSerial = (input = {}) => {
  return {
    'stockId': input.stock_id,
    'skuId': input.sku_id,
    'productId': input.product_id,
    'whId': input.wh_id,
    'binLocationId': input.bin_location_id,
    'shopId': input.shop_id,
    'grId': input.gr_id,
    'poId': input.po_id,
    'serialNumber': input.serial_number,
    'dateIn': input.date_in,
    'dateProduct': input.date_product,
    'dateExpire': input.date_expire,
    'unitInit': input.unit_init,
    'unitBalance': input.unit_balance,
    'cost': input.cost,
    'note': input.note,
    'isReady': input.is_ready,
    'serCode': input.ser_code,
    'createdBy': input.created_by,
    'createdAt': input.created_at,
    'sku': {
      'config': {
        'inventory': {
          'useLot': input.sku && input.sku.config && input.sku.config.inventory.use_lot || false,
          'useSerial': input.sku && input.sku.config && input.sku.config.inventory.use_serial || false,
        },
      },
      'skuId': input.sku && input.sku.sku_id,
      'skuCode': input.sku && input.sku.sku_code,
      'attributes': input.sku && input.sku.attributes,
      'barcode': input.sku && input.sku.barcode,
    },
    'product': {
      'productId': input.product && input.product.product_id,
      'productName': input.product && input.product.product_name,
      'unit': input.product && input.product.unit,
    },
    'warehouse': {
      'warehouseId': input.warehouse && input.warehouse.warehouse_id,
      'isDeleted': input.warehouse && input.warehouse.is_deleted,
      'warehouseName': input.warehouse && input.warehouse.warehouse_name,
      'shortName': input.warehouse && input.warehouse.short_name,
      'primary': input.warehouse && input.warehouse.primary,
      'info': {
        'address': input.warehouse && input.warehouse.info.address,
      },
      'binLocations': transformBins(input.warehouse && input.warehouse.bin_locations || []),
    },
    'serId': input.ser_id,
  }
}

export const transformSerials = (input = []) => {
  return input.map((item) => transformSerial(item))
}

export default {
  namespaced: true,

  state: {
    serialList: transformSerials([]),
    serialSingle: transformSerial({}),
    serialLatestCode: null,
  },

  mutations: {
    setSerialList(state, data) {
      state.serialList = transformSerials(data)
    },
    setSerialSingle(state, data) {
      state.serialSingle = transformSerial(data)
    },
    setSerialLatestCode(state, data) {
      state.serialLatestCode = data
    },
  },

  actions: {
    async getSerialList({ commit }, params = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getSerialList') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getSerialList')

        const response = await SerialService.getSerialList(params)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getSerialList')

        result = response.data

        if (result.success) {
          commit('setSerialList', result.data)
          this.dispatch('setPagination', result.meta)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getSerialLatestCode({ commit }, params) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getSerialLatestCode') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getSerialLatestCode')

        const response = await SerialService.getSerialLatestCode(params)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getSerialLatestCode')

        result = response.data

        if (result.success) {
          commit('setSerialLatestCode', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getSerialSingle({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getSerialSingle') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getSerialSingle')

        const response = await SerialService.getSerialSingle(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getSerialSingle')

        result = response.data

        if (result.success && result.data.length) {
          commit('setSerialSingle', result.data[0])
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async createSerial({ commit }, data = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('createSerial') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'createSerial')

        const response = await SerialService.createSerial(data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'createSerial')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updateSerial({ commit }, { id, data = {} }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('updateSerial') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'updateSerial')

        const response = await SerialService.updateSerial(id, data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'updateSerial')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updateSerialStatus({ commit }, { id, data = {} }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('updateSerialStatus') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'updateSerialStatus')

        const response = await SerialService.updateSerialStatus(id, data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'updateSerialStatus')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async deleteSerial({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('deleteSerial') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'deleteSerial')

        const response = await SerialService.deleteSerial(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'deleteSerial')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/Serial.js